export default {
  methods: {
    hasPermission(permissions) {
      const storedPermissions = this.$store.getters.permissions;
      if (storedPermissions == null || storedPermissions.length === 0) { return false; }
      return permissions.every(v => storedPermissions.includes(v));
    }
  }
}

export const PERM = {
  CATALOG : "CATALOG",

  CATALOG_TOWN: "CATALOG_TOWN",
  CATALOG_TOWN_EDIT: "CATALOG_TOWN_EDIT",
  CATALOG_TOWN_READ: "CATALOG_TOWN_READ",

  CATALOG_WORK_TYPE: "CATALOG_WORK_TYPE",
  CATALOG_WORK_TYPE_EDIT: "CATALOG_WORK_TYPE_EDIT",
  CATALOG_WORK_TYPE_READ: "CATALOG_WORK_TYPE_READ",

  CATALOG_SOURCE: "CATALOG_SOURCE",
  CATALOG_SOURCE_EDIT: "CATALOG_SOURCE_EDIT",
  CATALOG_SOURCE_READ: "CATALOG_SOURCE_READ",

  CATALOG_WORKER_SOURCE: "CATALOG_WORKER_SOURCE",
  CATALOG_WORKER_SOURCE_EDIT: "CATALOG_WORKER_SOURCE_EDIT",
  CATALOG_WORKER_SOURCE_READ: "CATALOG_WORKER_SOURCE_READ",

  CATALOG_JOB_TITLE: "CATALOG_JOB_TITLE",
  CATALOG_JOB_TITLE_EDIT: "CATALOG_JOB_TITLE_EDIT",
  CATALOG_JOB_TITLE_READ: "CATALOG_JOB_TITLE_READ",

  CATALOG_LOCATION_COST_TYPE: "CATALOG_LOCATION_COST_TYPE",
  CATALOG_LOCATION_COST_TYPE_EDIT: "CATALOG_LOCATION_COST_TYPE_EDIT",
  CATALOG_LOCATION_COST_TYPE_READ: "CATALOG_LOCATION_COST_TYPE_READ",

  CATALOG_LOCATION_STATUS: "CATALOG_LOCATION_STATUS",
  CATALOG_LOCATION_STATUS_EDIT: "CATALOG_LOCATION_STATUS_EDIT",
  CATALOG_LOCATION_STATUS_READ: "CATALOG_LOCATION_STATUS_READ",

  CATALOG_WORKER_COST_TYPE: "CATALOG_WORKER_COST_TYPE",
  CATALOG_WORKER_COST_TYPE_EDIT: "CATALOG_WORKER_COST_TYPE_EDIT",
  CATALOG_WORKER_COST_TYPE_READ: "CATALOG_WORKER_COST_TYPE_READ",

  CATALOG_DEPARTMENT: "CATALOG_DEPARTMENT",
  CATALOG_DEPARTMENT_EDIT: "CATALOG_DEPARTMENT_EDIT",
  CATALOG_DEPARTMENT_READ: "CATALOG_DEPARTMENT_READ",

  CATALOG_WORK_SERVICE: "CATALOG_WORK_SERVICE",
  CATALOG_WORK_SERVICE_EDIT: "CATALOG_WORK_SERVICE_EDIT",
  CATALOG_WORK_SERVICE_READ: "CATALOG_WORK_SERVICE_READ",

  CATALOG_VACANCY: "CATALOG_VACANCY",
  CATALOG_VACANCY_EDIT: "CATALOG_VACANCY_EDIT",
  CATALOG_VACANCY_READ: "CATALOG_VACANCY_READ",

  CATALOG_WORKER_STATUS: "CATALOG_WORKER_STATUS",
  CATALOG_WORKER_STATUS_EDIT: "CATALOG_WORKER_STATUS_EDIT",
  CATALOG_WORKER_STATUS_READ: "CATALOG_WORKER_STATUS_READ",

  CATALOG_LEAD_STATUS: "CATALOG_LEAD_STATUS",
  CATALOG_LEAD_STATUS_EDIT: "CATALOG_LEAD_STATUS_EDIT",
  CATALOG_LEAD_STATUS_READ: "CATALOG_LEAD_STATUS_READ",

  CATALOG_CUSTOMER_STATUS: "CATALOG_CUSTOMER_STATUS",
  CATALOG_CUSTOMER_STATUS_EDIT: "CATALOG_CUSTOMER_STATUS_EDIT",
  CATALOG_CUSTOMER_STATUS_READ: "CATALOG_CUSTOMER_STATUS_READ",

  CATALOG_PROJECT_STATUS: "CATALOG_PROJECT_STATUS",
  CATALOG_PROJECT_STATUS_EDIT: "CATALOG_PROJECT_STATUS_EDIT",
  CATALOG_PROJECT_STATUS_READ: "CATALOG_PROJECT_STATUS_READ",

  CATALOG_LEAD_SOURCE: "CATALOG_LEAD_SOURCE",
  CATALOG_LEAD_SOURCE_EDIT: "CATALOG_LEAD_SOURCE_EDIT",
  CATALOG_LEAD_SOURCE_READ: "CATALOG_LEAD_SOURCE_READ",

  CATALOG_RECRUIT_TAG: "CATALOG_RECRUIT_TAG",
  CATALOG_RECRUIT_TAG_EDIT: "CATALOG_RECRUIT_TAG_EDIT",
  CATALOG_RECRUIT_TAG_READ: "CATALOG_RECRUIT_TAG_READ",

  CATALOG_CITIZENSHIPS: "CATALOG_CITIZENSHIPS",
  CATALOG_CITIZENSHIPS_EDIT: "CATALOG_CITIZENSHIPS_EDIT",
  CATALOG_CITIZENSHIPS_READ: "CATALOG_CITIZENSHIPS_READ",

  CATALOG_DRIVER_LICENSE_CATEGORY: "CATALOG_DRIVER_LICENSE_CATEGORY",
  CATALOG_DRIVER_LICENSE_CATEGORY_EDIT: "CATALOG_DRIVER_LICENSE_CATEGORY_EDIT",
  CATALOG_DRIVER_LICENSE_CATEGORY_READ: "CATALOG_DRIVER_LICENSE_CATEGORY_READ",

  CATALOG_EMPLOYMENT_CATEGORY: "CATALOG_EMPLOYMENT_CATEGORY",
  CATALOG_EMPLOYMENT_CATEGORY_EDIT: "CATALOG_EMPLOYMENT_CATEGORY_EDIT",
  CATALOG_EMPLOYMENT_CATEGORY_READ: "CATALOG_EMPLOYMENT_CATEGORY_READ",

  WORKER: 'WORKER',
  WORKER_EDIT: 'WORKER_EDIT',
  WORKER_READ: 'WORKER_READ',
  WORKER_EDIT_OTHER: 'WORKER_EDIT_OTHER',
  WORKER_READ_OTHER: 'WORKER_READ_OTHER',

  TASK: 'TASK',
  TASK_EDIT: 'TASK_EDIT',
  TASK_READ: 'TASK_READ',
  TASK_EDIT_LOCATION: 'TASK_EDIT_LOCATION',
  TASK_READ_LOCATION: 'TASK_READ_LOCATION',
  TASK_EDIT_OTHER: 'TASK_EDIT_OTHER',
  TASK_READ_OTHER: 'TASK_READ_OTHER',

  RECRUIT: 'RECRUIT',
  RECRUIT_JOB_POSTING: 'RECRUIT_JOB_POSTING',
  RECRUIT_JOB_POSTING_EDIT: 'RECRUIT_JOB_POSTING_EDIT',
  RECRUIT_JOB_POSTING_READ: 'RECRUIT_JOB_POSTING_READ',
  RECRUIT_JOB_POSTING_EDIT_OTHER: 'RECRUIT_JOB_POSTING_EDIT_OTHER',
  RECRUIT_JOB_POSTING_READ_OTHER: 'RECRUIT_JOB_POSTING_READ_OTHER',

  RECRUIT_TASK: 'RECRUIT_TASK',
  RECRUIT_TASK_EDIT: 'RECRUIT_TASK_EDIT',
  RECRUIT_TASK_READ: 'RECRUIT_TASK_READ',
  RECRUIT_TASK_EDIT_OTHER: 'RECRUIT_TASK_EDIT_OTHER',
  RECRUIT_TASK_READ_OTHER: 'RECRUIT_TASK_READ_OTHER',

  RECRUIT_CANDIDATE: 'RECRUIT_CANDIDATE',
  RECRUIT_CANDIDATE_EDIT: 'RECRUIT_CANDIDATE_EDIT',
  RECRUIT_CANDIDATE_READ: 'RECRUIT_CANDIDATE_READ',
  RECRUIT_CANDIDATE_EDIT_OTHER: 'RECRUIT_CANDIDATE_EDIT_OTHER',
  RECRUIT_CANDIDATE_READ_OTHER: 'RECRUIT_CANDIDATE_READ_OTHER',

  RECRUIT_LOCATION_VACANCY: 'RECRUIT_LOCATION_VACANCY',
  RECRUIT_LOCATION_VACANCY_EDIT: 'RECRUIT_LOCATION_VACANCY_EDIT',
  RECRUIT_LOCATION_VACANCY_READ: 'RECRUIT_LOCATION_VACANCY_READ',
  RECRUIT_LOCATION_VACANCY_EDIT_OTHER: 'RECRUIT_LOCATION_VACANCY_EDIT_OTHER',
  RECRUIT_LOCATION_VACANCY_READ_OTHER: 'RECRUIT_LOCATION_VACANCY_READ_OTHER',

  CUSTOMER: 'CUSTOMER',
  CUSTOMER_EDIT: 'CUSTOMER_EDIT',
  CUSTOMER_READ: 'CUSTOMER_READ',
  CUSTOMER_EDIT_OTHER: 'CUSTOMER_EDIT_OTHER',
  CUSTOMER_READ_OTHER: 'CUSTOMER_READ_OTHER',

  LOCATION: 'LOCATION',
  LOCATION_EDIT: 'LOCATION_EDIT',
  LOCATION_READ: 'LOCATION_READ',
  LOCATION_EDIT_OTHER: 'LOCATION_EDIT_OTHER',
  LOCATION_READ_OTHER: 'LOCATION_READ_OTHER',
  LOCATION_EDIT_FINANCE: 'LOCATION_EDIT_FINANCE',
  LOCATION_READ_FINANCE: 'LOCATION_READ_FINANCE',

  LOCATION_VACANCY: 'LOCATION_VACANCY',
  LOCATION_VACANCY_EDIT: 'LOCATION_VACANCY_EDIT',
  LOCATION_VACANCY_READ: 'LOCATION_VACANCY_READ',

  ORGANIZATION: 'ORGANIZATION',
  ORGANIZATION_EDIT: 'ORGANIZATION_EDIT',
  ORGANIZATION_READ: 'ORGANIZATION_READ',

  USER: 'USER',
  USER_EDIT: 'USER_EDIT',
  USER_READ: 'USER_READ',

  ROLE: 'ROLE',
  ROLE_EDIT: 'ROLE_EDIT',
  ROLE_READ: 'ROLE_READ',

  STAFF: 'STAFF',
  STAFF_EDIT: 'STAFF_EDIT',
  STAFF_READ: 'STAFF_READ',

  REPORT: 'REPORT',
  REPORT_READ: 'REPORT_READ',

  REGISTER: 'REGISTER',
  REGISTER_READ: 'REGISTER_READ',
  REGISTER_READ_OTHER: 'REGISTER_READ_OTHER',

  ANALYTIC: 'ANALYTIC',
  ANALYTIC_READ: 'ANALYTIC_READ',
  ANALYTIC_READ_OTHER: 'ANALYTIC_READ_OTHER',

  STATISTIC: 'STATISTIC',
  STATISTIC_READ: 'STATISTIC_READ',
  STATISTIC_READ_OTHER: 'STATISTIC_READ_OTHER',
};



// WEBPACK FOOTER //
// ./src/utilites/permissions.js